var React = require('react');

function WindowSvgrepoCom (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m238.894,207.667v-190h-222.456v190h-16.438v30h16.438 222.455 16.439v-30h-16.438zm-126.228,0h-66.228v-160h66.228v160zm96.228,0h-66.228v-65h20.667v-30h-20.667v-65h66.228v160z"}));
}

WindowSvgrepoCom.defaultProps = {"version":"1.1","viewBox":"0 0 255.333 255.333","enableBackground":"new 0 0 255.333 255.333"};

module.exports = WindowSvgrepoCom;

WindowSvgrepoCom.default = WindowSvgrepoCom;
